import { Box, styled } from '@mui/material'

// Global UI
import { TypographyH3, TypographySpan } from '@/ui'

export const BreadCrumbDiv = styled(Box)(({ theme }) => ({
  background: '#E5E2DD',
  padding: `${theme.typography.pxToRem(15)} 0`,
}))

export const BreadCrumbTitle = styled(TypographyH3)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(18),
  fontWeight: 500,
  textTransform: 'uppercase',
  lineHeight: '1.44em',
  letterSpacing: theme.typography.pxToRem(0.02),
  color: '#1E1D24',
}))

export const BreadCrumbSubTitle = styled(TypographySpan)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(15),
  fontWeight: 400,
  textTransform: 'uppercase',
  lineHeight: '1.75em',
}))
